import FouGrid from 'src/components/layout/fou-grid/'
import FouGroup from 'src/components/layout/fou-group/'
import FouContainer from 'src/components/tools/fou-container/index.vue'
import {mapGetters} from 'vuex'
import AnimationProcessing from 'components/animations/processing'

export default {
  name: 'bulk-import-status',

  data () {
    return {
      mdlTempImportVersion: '',
      valError: ''
    }
  },

  components: {
    ...FouGrid,
    FouGroup,
    FouContainer,
    AnimationProcessing
  },

  methods: {
    fetchBulkImportStatus () {
      if (this.$store.getters['bulkImport/uploading']) {
        return false
      }
      if (!this.validateTempImportVersion(this.mdlTempImportVersion)) {
        return false
      }
      this.$store.dispatch('bulkImport/reset')
      this.$store.dispatch('bulkImport/fetchImportStatus', {tempImportVersion: String(this.mdlTempImportVersion)})
        .then()
    },
    simplifyMessages (message) {
      if (!message) {
        return message
      }
      if (message.includes('error 35: OpenSSL SSL_connect: SSL_ERROR_SYSCALL')) {
        return 'API connection to PIM failed'
      }
      if (message.includes('In Progress')) {
        return 'Background process is still running. Please try again after some time'
      }
      return message
    },
    clear () {
      this.$store.dispatch('bulkImport/reset')
      this.mdlTempImportVersion = ''
    },
    validateTempImportVersion (tmpNumber) {
      if (!tmpNumber || isNaN(parseInt(tmpNumber))) {
        this.valError = 'TempImportVersion is required and should be a number'
        return false
      }
      this.valError = ''
      return true
    },
    preventE (evt) {
      if (['-', '+', 'e', 'E', '.'].includes(evt.key)) {
        evt.preventDefault()
      }
    }
  },

  computed: {
    ...mapGetters('bulkImport', {
      'bulkImportStatus': ['bulkImportStatus'],
      'errorMessage': ['bulkImportError'],
      'searchedTempImportVersion': ['tempImportVersion'],
      'showBulkImportStatus': ['showBulkImportStatus'],
      'loading': ['uploading']
    })
  }
}
